import React, { useState } from "react";
import api from "../../services/api";
import storage from "../../services/storage";
import { Container } from "@mui/system";
import Logo from "../../assets/img/logo-reenergisa.png";
import { Grid, Card, Box, CardHeader, CardContent, Button, Typography, Tooltip } from '@mui/material';
import CustomLoading from "../../components/CustomLoading";
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import UndoIcon from '@mui/icons-material/Undo';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import DoneIcon from '@mui/icons-material/Done';
import KeyIcon from '@mui/icons-material/Key';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import './styles.css';

const LoginTerceirosPage = () => {
    const [showModal, setShowModal] = useState(false);
    const [valueEmail, setValueEmail] = useState("");
    const [valuePassword, setValuePassword] = useState("");
    const [errorText, setErrorText] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const handleKeyPress = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            if(!checkDisabled()){
                handlerClickCheck(event);
            }
            return true;
        }
    };

    const handleClickShowPassword = (event) => {
        event.preventDefault()
        setShowPassword(!showPassword);
    };

    const mouseDownShowPassword = (event) => {
        event.preventDefault();
    };

    async function handlerClickCheck(e) {
        e.preventDefault();
        setShowModal(true);

        var email = valueEmail;
        var password = valuePassword;

        if (email !== null && email !== undefined && email !== "" &&
            password !== null && password !== undefined && password !== "") {
            let requestBody = {
                email: email,
                senha: password,
                cod_auth: 'sem codigo'
            };

            api.initExternal.post('', requestBody).then((response) => {
                storage.setTerceiroEmail(response.data.data.data.user.email);
                storage.setTerceiroPass(response.data.data.data.user.pass);
                storage.setTerceiroUriQrCode(response.data.data.data.uri);
                window.location = '/login-terceiros-code'

                setShowModal(false);
            })
                .catch((exception) => {
                    console.error(`Error: ${exception}`);
                    setErrorText("Usuário não encontrado ou senha inválida!");
                    setShowModal(false);
                });

        } else {
            setErrorText("Email não pode ser vazio!");
            setShowModal(false);
        }
    }

    function checkDisabled() {

        var email = valueEmail;
        var password = valuePassword;

        return !(email !== null && email !== undefined && email !== "" &&
            password !== null && password !== undefined && password !== "");
    }

    return (
        <>
            <CustomLoading show={showModal} />

            <Container maxWidth="sm" className="text-center margin-top-50px">
                <Grid container direction="row" justifyContent="center" alignItems="center" mt={2} className="text-center padding-30px-15px">
                    <Grid item lg={8} md={8} sm={6} className="text-center">
                        <Card elevation={3} className="text-center padding-20px">
                            <Box>
                                <img src={Logo} className="width-100px" alt="logo" />
                            </Box>
                            <CardHeader title="EnergisaDash" subheader="Dashboards." />

                            <CardContent>
                                <Grid container className="margin-top-25px text-left">
                                    <Grid item lg={12} sm={12}>
                                        <Typography className="font-size-9-pt color-disabled">
                                            Informe seu usuário do EnergisaDash. <br />
                                            <br />
                                        </Typography>
                                    </Grid>

                                    <Paper
                                        component="form"
                                        sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 400 }}
                                    >
                                        <PeopleAltIcon color="primary" />
                                        <Divider sx={{ height: 28, m: 1 }} orientation="vertical" />
                                        <TextField
                                            name="input-email"
                                            sx={{ ml: 1, flex: 1 }}
                                            placeholder="E-mail"
                                            inputProps={{ 'aria-label': 'E-mail' }}
                                            value={valueEmail}
                                            onChange={(e) => setValueEmail(e.target.value)}
                                            onKeyPress={(e) => handleKeyPress(e)}
                                            variant="standard"
                                            error={errorText !== ""}
                                            helperText={errorText}
                                        />
                                    </Paper>

                                    <Paper
                                        className="senha-container"
                                        component="form"
                                        sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 400 }}
                                    >
                                        <KeyIcon color="primary" />
                                        <Divider sx={{ height: 28, m: 1 }} orientation="vertical" />
                                        <TextField
                                            name="input-senha"
                                            sx={{ ml: 1, flex: 1 }}
                                            placeholder="Senha"
                                            inputProps={{ 'aria-label': 'Senha' }}
                                            type={showPassword ? 'text' : 'password'}
                                            value={valuePassword}
                                            onChange={(e) => setValuePassword(e.target.value)}
                                            onKeyPress={(e) => handleKeyPress(e)}
                                            variant="standard"
                                            error={errorText !== ""}
                                        />
                                        <Divider sx={{ height: 28, m: 1 }} orientation="vertical" />
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={mouseDownShowPassword}
                                        >
                                            {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                        </IconButton>
                                        <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                                        <Tooltip title={"Confirmar"}>
                                            <span>
                                                <IconButton disabled={checkDisabled()} color="primary" sx={{ p: '10px' }} aria-label="done" onClick={(e) => handlerClickCheck(e)}>
                                                    <DoneIcon />
                                                </IconButton>
                                            </span>
                                        </Tooltip>
                                    </Paper>

                                    <Grid item lg={12} sm={12}>
                                        <Typography className="font-size-9-pt color-disabled">
                                            <br />
                                            <br />
                                            <br />
                                            Não sabe qual é seu usuário? <br />
                                            <br />
                                            <b>Outros usuários:</b> informe suas credenciais do EnergisaDash.<br />
                                        </Typography>
                                    </Grid>

                                    <Grid item lg={12} sm={12} className="text-right">
                                        <Button variant="outlined" startIcon={<UndoIcon />} onClick={() => window.location = '/'}>
                                            Voltar
                                        </Button>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>

                        <Grid container mt={1}>
                            <Grid item lg={12} sm={6} className="text-right padding-10px">
                                <Button className="color-disabled">Ajuda</Button>
                                <Button className="color-disabled">Privacidade</Button>
                                <Button className="color-disabled">Termos</Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Container>

        </>
    )
}

export default LoginTerceirosPage;